import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { setCodigoPostal, clearCodigoPostal } from "../actions";
import { makeStyles } from "@mui/styles";
import CodigoPostalSelector from "~business/codigoPostalSelector/CodigoPostalSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 20,
    paddingBottom: 100,
    maxWidth: 500,
    width: "100%",
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    provinciaSelected: state.provinciaSelected,
  }));

const CodigoPostalStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { provinciaSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearCodigoPostal());
  }, [dispatch]);

  const handleChange = (event: { target: { value: string | null } }) => {
    dispatch(setCodigoPostal(event.target.value));
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle label="¿Cuál es el Código Postal?" marginBottom={32} />
        </div>
        <CodigoPostalSelector
          label=""
          provinciaId={provinciaSelected}
          onChange={handleChange}
        />
      </div>
    </>
  );
});

export default CodigoPostalStep;
